import script from "./ShopSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopSummary.vue?vue&type=script&setup=true&lang=js"

import "./ShopSummary.vue?vue&type=style&index=0&id=b8c99126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8c99126"]])

export default __exports__